// @noflow

// **** Player event handlers pub/sub
const channels = {};

export const getEventChannel = channel => {
  if (channel && !channels[channel]) {
    channels[channel] = {};
  }

  const events = channel ? channels[channel] : {};

  const off = (eventType, fn) => {
    if (fn && events[eventType]) {
      events[eventType] = events[eventType].filter(x => x !== fn);
    } else {
      events[eventType] = [];
    }
  };

  const on = (eventType, fn) => {
    if (events[eventType]) {
      events[eventType].push(fn);
    } else {
      events[eventType] = [fn];
    }
  };

  const triggerEvent = (eventType, data) => {
    if (events[eventType]) {
      return events[eventType].map(callback => callback(data));
    }
    return [];
  };

  return {
    off,
    on,
    triggerEvent,
  };
};

export const resetEventChannel = channel => {
  channels[channel] = {};
};

const defaultChannel = getEventChannel('default');

export const { off, on, triggerEvent } = defaultChannel;

export default defaultChannel;
